module.exports = ".search-iput .search-submit-btn{float:right}.search-iput .form-group{overflow:hidden;padding-right:20px}\n"